import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "../features/Auth/auth.slice";
import vendorReducer from "../features/Vendor/vendor.slice";
import { rootApi } from "./apis/api.root";
import { invalidateAllTagsOnSignInMiddleware } from "./middleware/middleware";

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    [rootApi.reducerPath]: rootApi.reducer,
    auth: authReducer,
    vendor: vendorReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(rootApi.middleware)
      .concat(invalidateAllTagsOnSignInMiddleware([rootApi])),
});

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
